import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27fa39ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=27fa39ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa39ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27fa39ac')) {
      api.createRecord('27fa39ac', component.options)
    } else {
      api.reload('27fa39ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=27fa39ac&scoped=true", function () {
      api.rerender('27fa39ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyEditor/index.vue"
export default component.exports